import { AgencyService } from './../common-theme/api/agency.service';
import { Component, Injector, OnInit } from '@angular/core';
import { EmbedVideoService } from '../common-theme/index';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent extends SeoAwareBaseComponent implements OnInit {
  public youtubeUrl: string = 'https://www.youtube.com/watch?v=xDW-IrCqaW8';
  public videoInnerHTML: any;
  images: any[] = [
    { url: '/assets/images/home/slider/0.jpg' },
    { url: '/assets/images/home/slider/1.jpg' },
    { url: '/assets/images/home/slider/2.jpg' },
    { url: '/assets/images/home/slider/3.jpg' },
    { url: '/assets/images/home/slider/4.jpg' },
    { url: '/assets/images/home/slider/5.jpg' },
    { url: '/assets/images/home/slider/6.jpg' },
    { url: '/assets/images/home/slider/7.jpg' }
  ];
  bannerOpened = false;

  constructor(
    public agencyService: AgencyService,
    private embedService: EmbedVideoService,
    public injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.videoInnerHTML = this.embedService.embed(this.youtubeUrl);

    this.setTitle('Romanescu Park Residence, Craiova');
    this.setMetaDescription(`
      Complex rezidențial de amploare din Craiova, Romanescu Park este situat în imediata
      apropiere a unuia dintre cele mai mari parcuri din oraș, Romanescu. Proiectul include 14 clădiri
      ce respectă toate exigențele unui cartier modern, cum sunt locurile de parcare sau spații de
      joacă pentru cei mici.
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts